<template>
  <div class="breadCrumb">
    <ul class="breadCrumb_list">
      <li>
        <router-link to="/">トップ</router-link>
      </li>
      <li v-for="(item, i) in $route.meta.breadCrumb" :key="i">
        <router-link v-if="item.link" :to="item.link">
          {{ item.label }}
        </router-link>
        <span v-else>{{ item.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
export default {
  name: 'BreadCrumb'
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.breadCrumb {
  overflow: auto;
  white-space: nowrap;
  margin-top: 23px;
  padding: 0 16px 8px;

  @include mixins.media(lg) {
    padding-left: 0;
    padding-right: 0;
  }

  &_list {
    display: flex;
    font-size: 1.2rem;
    color: var.$color-hidden-text;

    @include mixins.media(lg) {
      padding-left: 20px;
      padding-right: 20px;
      margin-left: auto;
      margin-right: auto;
      max-width: 1128px;
    }

    li {
      &:not(:first-child) {
        &::before {
          content: '>';
          font-size: 1rem;
          margin-left: 1.4rem;
          margin-right: 1.4rem;
        }
      }
      &:last-child {
        padding-right: 16px;
      }
    }
  }
}
</style>
